module.exports = __webpack_public_path__ + "img/5D5854_1A1714_373330_2C2424-256px.032c0be2.png";